import Link from 'next/link'
import styles from './Button.module.scss'

export default function Button({ href, className, children, ...props }) {
  let buttonClassName = [styles.button, className ?? undefined].join(' ')

  if (href) {
    return (
      <Link href={href} className={buttonClassName} {...props}>
        {children}
      </Link>
    )
  }

  return (
    <button className={buttonClassName} {...props}>
      {children}
    </button>
  )
}
